import { GetFileRequestContent, GetFileResponseContent } from "@equaliq/api-model";
import { createApiRequest } from "../common";

/**
 * API function to retrieve a file by ID
 * @param request File retrieval parameters
 * @returns Promise with file details and optional download URL
 */
export const getFileApi = async (request: GetFileRequestContent): Promise<GetFileResponseContent> => {
  const apiRequest = createApiRequest<GetFileResponseContent>('post', '/files/get');
  return apiRequest(request);
};
